<template>
  <!-- Category search -->
  <el-dialog
    title="Брэнд сонгох"
    :visible.sync="show"
    @close="closeDialog"
    width="30%"
  >

    <div>
      <el-select
        placeholder="Бренд сонгоно уу"
        v-model="filterText"
        @change="selectChange"
        style="width: 100%"
        filterable
        class="ml10"
        value-key="pkey"
        remote
        reserve-keyword
        :remote-method="searchBrand"
      >
        <el-option
          v-for="(item, index) in brands"
          :key="index"
          :label="item.brand_monName"
          :value="item"
        >
        </el-option>
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="show = false">Cancel</el-button>
      <el-button type="success" @click="returnBrands">
        Бренд сонгох
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import services from '../../../helpers/services'
export default {
  name: 'brandsSearchDialog',
  props: [
    'visibleBrandDialog'
  ],
  data () {
    return {
      filterText: '',
      loading: false,
      brands: [],
      brandTempValue: null,
      show: this.visibleBrandDialog
    }
  },

  mounted () {
    this.getBrands()
  },

  methods: {
    async searchBrand (text) {
      if (text !== '' && text !== undefined) {
        this.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(this.getBrands(text), 1000)
        this.loading = false
      } else if (text === '') {
        this.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(this.getBrands(text = ''), 1000)
        this.loading = false
      }
    },
    selectChange (item) {
      this.filterText = item.brand_monName
      this.brandTempValue = item
    },
    getBrands (text = '') {
      services.getBrands(text).then((response) => {
        this.brands = response.datas
        this.loading = false
      })
    },
    closeDialog () {
      this.$emit('update:visibleBrandDialog', false)
    },
    returnBrands () {
      const tempBrands = this.brandTempValue
      if (tempBrands !== null) {
        this.$emit('update:brands', tempBrands)
        this.show = false
      } else {
        this.$notify.error({
          title: 'Oops',
          position: 'bottom-left',
          message: 'Боенд сонгоно уу',
          duration: 2000
        })
      }
    }
  }
}
</script>
